import { Row } from "antd";
import "./UpgradeRequiredBanner.scss";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ceoLetterState, memberState } from "../../state/atoms";
import LeftTrapeze from "../icons/LeftTrapeze";
import LeftLine from "../icons/LeftLine";
import { FINAL_DATE_MONTH_SHORT } from "../../util/constants";
import WarningIconTriangle from "../icons/WarningIconTriangle";
import { Button } from "../account/misc/Button";
import { useEffect, useState } from "react";
import { env } from "../../env/env";

export default function UpgradeRequiredBanner() {
  const member = useRecoilValue(memberState);
  const setShowCeoLetter = useSetRecoilState(ceoLetterState);
  const [smallScreen, setSmallScreen] = useState(false);

  useEffect(() => {
    if (window.outerWidth <= 1107) {
      setSmallScreen(true);
    }
    const handler = () => setSmallScreen(window.innerWidth <= 1107);
    window.addEventListener('resize', handler)
    return () => {
      window.removeEventListener('resize', handler);
    }
  }, [setSmallScreen]);

  function onUpgradeNow() {
    if (!member || !member.id) return;
    window.location.href = env.dashboardPath + "/account/plan";
  }

  return (
    <Row>
      <div className={`home-banner dsab update-req`}>
        <div className={`update-required-banner ${smallScreen ? 'mobile' : ''}`}>
          <div className="left-section">
            {!smallScreen && <LeftTrapeze/>}
            {!smallScreen && <LeftLine/>}
            <div className="text">
              <WarningIconTriangle/>
              <span>Upgrade required by {FINAL_DATE_MONTH_SHORT}</span>
            </div>
          </div>
          <div className="right-section">
            <div className="text">
              Your free access is expiring. Unlock the New Design Plan.
            </div>

            {!member.viewOnly && <Button type={'Primary'} onClick={onUpgradeNow}>Upgrade Now</Button>}
            <span onClick={() => setShowCeoLetter(true)}>CEO Letter</span>
          </div>
        </div>
      </div>
    </Row>
  );
}
